import { connect } from 'react-redux';
import { compose, withPropsOnChange } from 'recompose';
import { get } from 'lodash';

import WithShop from './WithShop';
import { fetchBarbers } from '../barbers/actions';

const WithFetchBarbers = compose(
  WithShop,
  connect(null, { fetchBarbers }),
  withPropsOnChange(
    (props, nextProps) => get(props, 'shop.route') !== get(nextProps, 'shop.route'),
    (props) => {
      const shopId = get(props, 'shop.route');
      if (shopId) {
        props.fetchBarbers(shopId);
      }
    },
  ),
);

export default WithFetchBarbers;



// WEBPACK FOOTER //
// ./src/app/hoc/WithFetchBarbers.js